import Paper from '@mui/material/Paper';
import { RootStateOrAny, useSelector } from 'react-redux';
import { IEMDescription } from './IEMDescription';
import { RadarChartSection } from './RadarChartSection';
import { FeaturedTechnology } from './FeaturedTechnology';
import { DriverCount } from './DriverCount';
import { DriverConfiguration } from './DriverConfiguration';
import { FrequencyResponse } from './FrequencyResponse';
import { Sensitivity } from './Sensitivity';
import { Impedance } from './Impedance';
import { Crossover } from './Crossover';
import { Isolation } from './Isolation';
import { Box } from '@mui/material';
import layout from '../../styles/layout.module.css';
import { CIEM } from '../../interfaces/ciem';



const IemModelExcerpt = ( {iem  }: {iem: CIEM})=> {
    return (
        iem && (
            <Box  style={{ width: '98%', margin: 'auto' }}>
                <RadarChartSection chartData={iem.radar_chart} />
                <IEMDescription model={iem.name} description={iem.description} />
                <FeaturedTechnology technology={iem.featured_technology} />
                <DriverCount model={iem.name} drivers={iem.driver_type_and_count} />
                <DriverConfiguration model={iem.name} driverConfig={iem.driver_configuration} />
                <FrequencyResponse model={iem.name} frequencyResponse={iem.frequency_response} />
                <Sensitivity model={iem.name} sensitivity={iem.sensitivity} />
                <Impedance model={iem.name} impedance={iem.impedance} />
                <Crossover model={iem.name} crossover={iem.crossover} />
                <Isolation model={iem.name} isolation={iem.isolation} />
            </Box>
        )
    );
};

export const IEMModelDetail = () => {
    const iem = useSelector((state:  RootStateOrAny) => state.rootReducer.currentModel.currentModel) as CIEM;

    return (
        <Paper elevation={0} className={layout.containerScrollable}>
            <IemModelExcerpt iem={iem} />
        </Paper>
    );
};
